import { UserDetails } from '../types/user';

export class ActionOwnerName {
  private static neonUserId: string | null = null;

  public static getActionOwnerName(userDetails: UserDetails | undefined): string {
    if (!userDetails || !ActionOwnerName.neonUserId) return 'You';
    if (userDetails.neonUserId === ActionOwnerName.neonUserId) return 'You';
    if (!userDetails.firstName || !userDetails.lastName) return '';

    return `${userDetails.firstName} ${userDetails.lastName}`;
  }

  public static setNeonUserId(neonUserId: string) {
    ActionOwnerName.neonUserId = neonUserId;
  }
}
